import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'h2h_last_league';

/** Persist the last leagueId the player navigated to via a /play/:leagueId route.
 *  This is session-level memory so the tab bar always returns you to the league
 *  you were on — not your default — after a detour to /u/:userId, /settings, etc. */
export function saveLastLeague(leagueId: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, leagueId);
  } catch {
    // Private mode / quota exceeded — safe to ignore.
  }
}

export function readLastLeague(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Saves the leagueId to session storage whenever it changes (and is non-null). */
export function useLastLeague(leagueId: string | null): void {
  const saved = useRef<string | null>(null);
  useEffect(() => {
    if (leagueId && leagueId !== saved.current) {
      saved.current = leagueId;
      saveLastLeague(leagueId);
    }
  }, [leagueId]);
}
